import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { FieldValue, arrayRemove } from "firebase/firestore";
import { db } from "../../lib/firebaseCompat";

import Edit from "../shared/Edit";
import AdminOnly from "../shared/AdminOnly";

import { useAuth } from "../../hooks/usehooks.com/use-auth";
import { useTooltip } from "../../hooks/useTooltip";
import { useOrganization } from "../../hooks/useOrganization";

export default function UserTr({ user, currentUserId }) {
  const auth = useAuth();
  const organization = useOrganization();
  const currentOrganizationId = organization.current?.id;
  const tooltipRef = useTooltip();
  const [isAdmin, setIsAdmin] = useState(false);
  const isMe = user.uid === auth?.user?.uid;

  // move this someplace databasey
  const orgRef = db.collection("organizations").doc(currentOrganizationId);
  const memberRef = orgRef.collection("members").doc(user.uid);

  useEffect(() => {
    (async () => {
      try {
        const snapshot = await memberRef.get();
        const membership = snapshot.data();
        if (!membership) return;
        setIsAdmin(membership.role === "admin");
      } catch (err) {
        // can't check for admin unless admin
        setIsAdmin(false);
      }
    })();
  }, [user, organization]);

  const handleToggleAdmin = async () => {
    const newIsAdmin = !isAdmin;
    const role = newIsAdmin ? "admin" : "user";
    setIsAdmin(newIsAdmin); // optimistically update
    try {
      await memberRef.update({ role });
    } catch (err) {
      console.error(err);
      setIsAdmin(isAdmin); // revert because of error
      M.toast({ html: `Error setting membership to ${role}.` });
    }
  };

  const remove = async (user) => {
    try {
      await memberRef.delete();
      await orgRef.update({
        memberUids: arrayRemove(user.uid),
      });
      M.toast({
        html: "User removed from organization. Please refresh after 30 seconds.",
      });
    } catch (err) {
      console.error(err);
      M.toast({
        html: "You don't have permission to remove users.",
      });
    }
  };

  return (
    <tr>
      <td>{user.displayName}</td>
      <td>{user.email}</td>
      <td>
        {isMe ? (
          <a className="btn-small red" onClick={() => auth.signOut()}>
            Logout
          </a>
        ) : (
          <AdminOnly>
            <div className="switch">
              <label>
                <input
                  type="checkbox"
                  checked={isAdmin}
                  onChange={handleToggleAdmin}
                />
                <span className="lever"></span>
                Admin
              </label>
            </div>
          </AdminOnly>
        )}
      </td>
      <td>
        {isMe ? (
          <Edit at="/user/edit" tooltip="Edit your user account" />
        ) : (
          <AdminOnly>
            <i
              className="material-icons red-text cursor-pointer"
              onClick={() => remove(user)}
              data-tooltip="Remove this user from the organization"
              data-position="left"
              ref={tooltipRef}
            >
              remove_circle
            </i>
          </AdminOnly>
        )}
      </td>
    </tr>
  );
}

UserTr.propTypes = {
  user: PropTypes.shape({
    uid: PropTypes.string,
    displayName: PropTypes.string,
    email: PropTypes.string,
  }),
  currentUserId: PropTypes.number,
};
